import React from "react";
import { CustomModal } from "./styledModal";
import { StyledButton } from "./styledElements";

const DeleteModal = ({
  showDelete,
  onCancel,
  onsubmit,
  title,
  modalTitle = "Confirm Delete",
}) => {
  return (
    <CustomModal
      title={modalTitle}
      open={showDelete}
      className="rounded-md"
      onClose={onCancel}
      onCancel={onCancel}
      footer={[
        <StyledButton
          key="cancel"
          onClick={onCancel}
          background="white"
          color="black"
        >
          Cancel
        </StyledButton>,
        <StyledButton key={"submit"} onClick={onsubmit}>
          Delete
        </StyledButton>,
      ]}
    >
      <p>Are You sure to delete {title && title}?</p>
    </CustomModal>
  );
};

export default DeleteModal;

export const DisableEnableModal = ({
  showModal,
  onCancel,
  onsubmit,
  title,
  activate,
  modalTitle = activate ? "Activate User" : "Deactivate User?",
}) => {
  return (
    <CustomModal
      title={modalTitle}
      open={showModal}
      className="rounded-md"
      onClose={onCancel}
      onCancel={onCancel}
      footer={[
        <StyledButton
          key="cancel"
          onClick={onCancel}
          background="white"
          color="black"
        >
          Cancel
        </StyledButton>,
        <StyledButton key={"submit"} onClick={onsubmit}>
          {activate ? "Activate" : "Deactivate"}
        </StyledButton>,
      ]}
    >
      <p>
        Are you sure to {activate ? "Activate" : "Deactivate"}
        <strong> {title && title}</strong>?
      </p>
    </CustomModal>
  );
};
